import { createContext } from "react";

// type for the context
type contextType = {
  backgroundColor?: string;
  logAndSetBackgroundColor?: (color: string) => void;//React.Dispatch<React.SetStateAction<string>>;
  targetColors?: string[];
  logAndSetTargetColors?: (updateFunc: ((cur:string[]) => string[])) => void;//React.Dispatch<React.SetStateAction<string[]>>;
  projectileColor?: string;
  logAndSetProjectileColor?: (color: string) => void;//React.Dispatch<React.SetStateAction<string>>;
  targetVel?: number;
  logAndSetTargetVel?: (vel: number) => void;//React.Dispatch<React.SetStateAction<number>>;
  targetAcc?: number;
  logAndSetTargetAcc?: (acc: number) => void;//React.Dispatch<React.SetStateAction<number>>;
  duration?: number;
  logAndSetDuration?: (dur: number) => void;//React.Dispatch<React.SetStateAction<number>>;
};

const SettingsContext = createContext<contextType>({}); // context to be exported
export default SettingsContext;
